import { render, staticRenderFns } from "./Intro-start.vue?vue&type=template&id=241d5038"
import script from "./Intro-start.vue?vue&type=script&lang=js"
export * from "./Intro-start.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports